$(function() {

	$('[name="tabs"]').change(function() {
		window.location.href = $(this).val();
	});

});